export default {
  projectDesc: '一个让网页播放视频更简单的 <strong>Vue2</strong> 插件',
  demo: {},
  option: {
    url: '视频文件地址',
    loop: '是否循环播放',
    auto: '自动开始播放视频<br><code>play</code> 正常自动播放<br><code>muted</code> 静音自动播放',
    poster: '视频播放前的封面照片'
  },
  event: {
    play: '视频开始播放',
    pause: '视频暂停',
    end: '视频播放完成，在视频正常播放完成时，触发 <code>end</code> 事件之前会触发 <code>pause</code> 事件'
  }
}
